export const updateTableObjects = (params) => {
  const { tableObjects, otherCalculations, caseLists, cases, selectedTypes } =
    params;

  return tableObjects.map((obj) => {
    const empCalc = otherCalculations?.[caseLists]?.[obj?.id] || {};

    if (cases === "isThirdCase") {
      const {
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig,
        phicArr,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        earnedBasic,
        earnedPeraAda,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig,
        phic: phicArr,
        netPay: netAmount,
      };
    }
    //  else if (cases === "isSecondCase") {
    //   const { phic, pagibig, gsislr, earnedBasic, earnedPeraAda } = empCalc;
    //   return {
    //     ...obj,
    //     phic,
    //     pagibig,
    //     earnedBasic,
    //     earnedPeraAda,
    //     gsislr,
    //   };
    // }
    else if (cases === "isFourthCase") {
      const {
        proratedApRate,
        lateUtCurrentAss,
        earnedCurrAss,
        absencesLeaves_1,
        absencesLeaves_2,
        lateUtAirportAss,
        totalEarned,
        numberOfDuty,
        overpayment,
        excessAirportDuty,
        airportDutyEarned,
        flagRaising,
        netEarned,
        tax,
        apRate,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        apRate,
        proratedApRate,
        latesUtPerMinute3: lateUtCurrentAss,
        earnedCurrentAssignment: earnedCurrAss,
        absencesLeaves: absencesLeaves_1,
        absencesLeaves2: absencesLeaves_2,
        latesUtPerMinute4: lateUtAirportAss,
        earnedAirportDuties: airportDutyEarned,
        totalEarned,
        overpayment,
        totalDaysDuty: numberOfDuty,
        flagRaising,
        excessAirportDuty,
        netEarned,
        tax,
        netAmount,
      };
    } else if (cases === "isFifthCase") {
      const {
        absencesDays,
        absencesMins,
        earnedFoPeriod,
        overpayment,
        flagRaising,
        fivePercent,
        tenPercent,
        threePercent,
        twoPercent,
        totalTax,
        netPay,
      } = empCalc;

      return {
        ...obj,
        absencesDays,
        absencesMins,
        earnedForThePeriod: earnedFoPeriod,
        3: threePercent,
        2: twoPercent,
        5: fivePercent,
        10: tenPercent,
        totalTax,
        netPay,
        overpayment,
        flagRaising,
      };
    } else if (cases === "isSixthCase") {
      const {
        overpayment,
        flagRaising,
        noOfDays,
        earnedForThePeriod,
        threePercent,
        twoPercent,
        fivePercent,
        tenPercent,
        totalTax,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        overpayment,
        flagRaising,
        earnedForThePeriod,
        3: threePercent,
        2: twoPercent,
        5: fivePercent,
        10: tenPercent,
        noOfDays,
        totalTax,
        netPay: netAmount,
      };
    } else if (cases === "isSeventhCase") {
      const { netPay, tax, pagibig, phic } = empCalc;

      if (selectedTypes?.payItems === "Last") {
        return {
          ...obj,
          netPay,
          tax,
          pagibig,
          // phic,
        };
      }

      return {
        ...obj,
        netPay,
        // phic,
        tax,
      };
    } else if (cases === "isEightCase") {
      const {
        dailyRate,
        perMinute,
        earnedForThePeriod,
        netAmount,
        tax,
        overpayment,
        flagRaising,
        numberOfDuty,
        daysEarned,
        apRate,
      } = empCalc;
      return {
        ...obj,
        apRate,
        dailyRate,
        perMinute,
        overpayment,
        flagRaising,
        earnedForThePeriod,
        OfDutyForCiaMciaBinocRangeTo1519: numberOfDuty,
        daysEarned,
        netPay: netAmount,
        tax,
      };
    } else if (cases === "isEleventhCase") {
      const {
        twoPercent,
        netAmount,
        numberOfDuty,
        proratedRate,
        gratuityPay,
        totalEarned,
        threePercent,
        // absMins,
      } = empCalc;

      console.log("numberOfDuty", numberOfDuty);

      return {
        ...obj,
        2: twoPercent,
        OfDutyForCiaMciaBinocRangeTo1519: numberOfDuty,
        gratuityPay,
        proratedRate,
        totalEarned,
        // absMins,
        tax3: threePercent,
        netAmount,
      };
    } else if (cases === "isTwelvethCase") {
      const {
        apRate,
        ciaMciaBinoc,
        proratedApRate,
        apRateForBackPay,
        absenceLeavesCurAss,
        latesUtCurAss,
        earnedCurrAss,
        absencesLeavesAirport,
        lateUtAirportAss,
        airportDutyEarned,
        excessAirportDuties,
        overpayment,
        flagRaising,
        netEarned,
        totalEarned,
        netAmount,
      } = empCalc;
      return {
        ...obj,
        apRate,
        totalDaysDuty: ciaMciaBinoc,
        proratedApRate,
        apRateForBackPay,
        absencesLeaves: absenceLeavesCurAss,
        latesUtPerMinute3: latesUtCurAss,
        earnedCurrentAssignment: earnedCurrAss,
        absencesLeaves2: absencesLeavesAirport,
        latesUtPerMinute4: lateUtAirportAss,
        earnedAirportDuties: airportDutyEarned,
        excessAirportDuties,
        overpayment,
        flagRaising,
        netEarned,
        totalEarned,
        netAmount,
      };
    } else if (cases === "isTenthCase") {
      const { myDiff, yeDiff, netPay, tax } = empCalc;
      return {
        ...obj,
        myDiff,
        yeDiff,
        netPay,
        tax,
      };
    } else if (
      selectedTypes.payrollTypes === "BP" &&
      selectedTypes.payItems === "Addendum Payroll"
    ) {
      const {
        earnedBasic,
        earnedPeraAda,
        netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        phic,
        pagibig,
        gsisLR,
      } = empCalc;

      const isZero = (val) => parseFloat(val) === 0;
      const shouldZeroOutDeductions =
        isZero(earnedBasic) && isZero(earnedPeraAda);

      return {
        ...obj,
        earnedBasic,
        earnedPeraAda,
        netPay: netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
        pagibig: shouldZeroOutDeductions ? 0 : pagibig,
        phic: shouldZeroOutDeductions ? 0 : phic,
        gsisLR: shouldZeroOutDeductions ? 0 : gsisLR,
      };
    } else {
      const {
        earnedBasic,
        earnedPeraAda,
        netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
      } = empCalc;

      return {
        ...obj,
        earnedBasic,
        earnedPeraAda,
        netPay: netAmount,
        overpaymentBasic,
        overpaymentPeraAda,
        tax,
      };
    }
  });
};

export const updateTableObjects_1 = (params) => {
  const {
    tableObjects,
    lateUtLogs,
    lateUtLogsAirport,
    noOfDuties,
    daysInMonth,
    periodCount,
    monthNames,
    cases,
    employees,
  } = params;

  const firstItem = employees[0];

  console.log("firstItem", firstItem);

  return tableObjects.map((obj) => {
    if (obj.id !== firstItem?.id) return obj;
    const updatedLogs = lateUtLogs[obj?.id];

    console.log("updatedLogs", updatedLogs);
    const updatedLogsAirport = lateUtLogsAirport[obj?.id];
    const daysInAMonth = daysInMonth[obj?.id];
    const updatedCountPrd = periodCount[obj?.id];
    const daysToBeDeducted = updatedLogs?.totalAbsences;
    const minutesToBeDeducted = updatedLogs?.totalDeductedMins;
    const daysDeductedAirport = updatedLogsAirport?.totalAbsences;
    const minutesDeductedAirport = updatedLogsAirport?.totalDeductedMins;
    const halfDaysToBeDeducted = updatedLogs?.totalHalfDays;
    const workingDates = updatedLogs?.workingDates;
    const noOfDutiesInAirport = noOfDuties[obj?.id];
    const allMinsIncurred = updatedLogs?.allMinsIncurred;
    const monthNamesArr = monthNames[obj?.id];
    const dateOfAbsences = updatedLogs?.dateOfAbsences[obj?.id];

    if (cases === "isSixthCase") {
      return {
        ...obj,
        daysToBeDeducted,
        minsToBeDeducted: minutesToBeDeducted,
        updatedCountPrd,
        monthNamesArr,
      };
    }
    if (cases === "isEightCase") {
      return {
        ...obj,
        daysToBeDeducted,
        minsToBeDeducted: minutesToBeDeducted,
        workingDates,
        updatedCountPrd,
        monthNamesArr,
        allMinsIncurred,
      };
    }
    if (cases === "isEleventhCase") {
      return {
        ...obj,
        daysToBeDeducted,
        minsToBeDeducted: minutesToBeDeducted,
        workingDates,
        updatedCountPrd,
        monthNamesArr,
        allMinsIncurred,
      };
    }
    if (cases === "isTwelvethCase") {
      return {
        ...obj,
        abs: daysToBeDeducted,
        latesUtPerMinute: minutesToBeDeducted,
        abs2: daysDeductedAirport,
        latesUtPerMinute2: minutesDeductedAirport,
        noOfDuties: noOfDutiesInAirport,
        workingDates,
        dateOfAbsences,
        updatedCountPrd,
        monthNamesArr,
      };
    }

    return {
      ...obj,
      daysInAMonth,
      minutesToBeDeducted,
      daysToBeDeducted,
      halfDaysToBeDeducted,
      updatedCountPrd,
      monthNamesArr,
    };
  });
};

export const updateTableObjects_2 = (params) => {
  const { updatedTableObj, otherCalculations, caseLists, cases } = params;

  return updatedTableObj.map((obj) => {
    const empCalc = otherCalculations?.[caseLists]?.[obj?.id] || {};

    if (cases === "isThirdCase") {
      const {
        deductionsDueToLeavesAbsencesAndTardinessBasic,
        deductionPeraAda,
        peraDeducts,
        earnedBasic,
        earnedPeraAda,
        gsisInsuredDays,
        basicRateForBackPay,
        peraAdaForBackPay,
        netAmount,
      } = empCalc;

      return {
        ...obj,
        gsisInsuredDays,
        basicRateForBackPay,
        peraAdaForBackPay,
        deductionsDueToLeavesAbsencesAndTardinessBasic,
        deductionPeraAda,
        earnedBasic,
        earnedPeraAda,
        netPay: netAmount,
      };
    } else if (cases === "isSixthCase") {
      const {
        basicRateForBackPay,
        netAmount,
        absencesDays,
        absencesMins,
        earnedForThePeriod,
      } = empCalc;

      return {
        ...obj,
        basicRateForBackPay,
        absencesDays,
        absencesMins,
        earnedForThePeriod,
        netPay: netAmount,
      };
    } else if (cases === "isEightCase") {
      const { netAmount, daysEarned, totalLatesUt, latesUtDeduction } = empCalc;

      return {
        ...obj,
        daysEarned,
        latesUtDeduction,
        noOfLatesIncurred: totalLatesUt,
        netPay: netAmount,
      };
    } else if (cases === "isEleventhCase") {
      const {
        netAmount,
        inService,
        proratedRate,
        minsToBeDeduc,
        absMins,
        earned,
        twentyPercent,
        totalEarned,
        threePercent,
      } = empCalc;
      return {
        ...obj,
        netPay: netAmount,
        noOfDaysPresent: inService,
        proratedRate,
        minsDeducted: minsToBeDeduc,
        absMins,
        earned,
        20: twentyPercent,
        totalEarned,
        tax3: threePercent,
        netAmount,
      };
    } else if (cases === "isTwelvethCase") {
      const { apRateForBackPay, proratedApRate } = empCalc;
      return {
        ...obj,
        apRateForBackPay,
      };
    }
  });
};

export const updateTableObjects_3 = (params) => {
  const { modifiedTable, otherCalculations, caseLists, cases } = params;

  return modifiedTable.map((obj) => {
    const empCalc = otherCalculations?.[caseLists]?.[obj?.id] || {};

    if (cases === "isThirdCase") {
      const { netAmount } = empCalc;
      return {
        ...obj,
        netPay: netAmount,
      };
    } else if (cases === "isSixthCase") {
      const { netAmount, absencesDays, earnedForThePeriod } = empCalc;

      return {
        ...obj,
        earnedForThePeriod,

        netPay: netAmount,
        absencesDays,
      };
    } else if (cases === "isEightCase") {
      const { netAmount, latesUtDeduction, earnedForThePeriod } = empCalc;
      return {
        ...obj,
        earnedForThePeriod,
        latesUtDeduction,
        netPay: netAmount,
      };
    } else if (cases === "isEleventhCase") {
      const { netAmount, proratedRate } = empCalc;
      return {
        ...obj,
        proratedRate,
        netPay: netAmount,
      };
    } else if (cases === "isTwelvethCase") {
      const {
        proratedApRate,
        apRateForBackPay,
        absenceLeavesCurAss,
        latesUtCurAss,
        earnedCurrAss,
        airportAugmentationRate,
        airportAugAmt,
        absencesLeavesAirport,
        lateUtAirportAss,
        airportDutyEarned,
        netEarned,
        totalEarned,
        netAmount,
      } = empCalc;
      return {
        ...obj,
        proratedApRate,
        apRateForBackPay,
        absencesLeaves: absenceLeavesCurAss,
        latesUtPerMinute3: latesUtCurAss,
        earnedCurrentAssignment: earnedCurrAss,
        airportAugmentationRate,
        amountEarnedAirportAugmentation: airportAugAmt,
        absencesLeaves2: absencesLeavesAirport,
        latesUtPerMinute4: lateUtAirportAss,
        earnedAirportDuties: airportDutyEarned,
        netEarned,
        totalEarned,
        netAmount,
      };
    }
  });
};
